export default import.meta.ROLLDOWN_FILE_URL_87nMgSwlW0cl4fQMqRROJQ